import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import FirstWizardPage from "./FirstWizardPage";
import SecondWizardPage from "./SecondWizardPage";
import { injectIntl } from "react-intl";
import { confirm } from 'devextreme/ui/dialog';

class ProjectOrderBatchModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'ForecastWizardModalValidator';
        this.state = {
            changed: false,
            page: null,
            forecastBatchId: null
        };
    }
    handleForecastBatchMultipleProjectOrders = (forecastBatchId) => {
        this.setState({ forecastBatchId, changed: false });
    }
    tabFirstWizardPage = () => {
        return (
            <div style={{ overflowY: 'auto' }}>
                <FirstWizardPage
                    {...this.props}
                    onHandleForecastBatchMultipleProjectOrders={this.handleForecastBatchMultipleProjectOrders}
                    onValueChanged={this.onValueChanged}
                />
            </div>
        );
    };
    tabSecondWizardPage = (forecastBatchId) => {
        return (
            <div style={{ overflowY: 'auto' }}>
                <SecondWizardPage
                    {...this.props}
                    forecastBatchId={forecastBatchId}
                    onFilesCountChanged={(fCount) => { if (this.state.fileCount !== fCount) { this.setState({ fileCount: fCount }) } }}
                    onValueChanged={this.onValueChanged}
                    onClose={this.onClose}
                />
            </div>
        );
    };
    onValueChanged = (changed, page) => {
        this.setState({ changed, page });
    }
    onClose = async (e, skipChecks) => {
        if (this.state.changed && !skipChecks) {
            let warningMessage = this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' });
            let warningMessageTitle = this.props.intl.formatMessage({ id: 'GENERAL.WARNING.LEAVE_CHANGES_TITLE' });
            let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);

            if (!result) {
                return;
            }
        }

        this.setState({ changed: false, page: null, forecastBatchId: null }, () => {
            if (this.props.visible) {
                let forecastBatchNeedsRefresh = true;
                this.props.onClose(forecastBatchNeedsRefresh);
                this.props.navigate(this.props.workflowItem.paths.listPath);
            }
        })
    }
    // this.props.forecastBatchId comes from List
    // this.state.forecastBatchId comes from FirstWizardPage after creating a forecast batch
    get effectiveForecastBatchId() {
        return this.props.forecastBatchId || this.state.forecastBatchId;
    }
    render() {
        if (!this.props.visible) {
            return null;
        }
        
        return (
            <Popup
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title={this.props.intl.formatMessage({ id: 'CONTRACT.WF.COSTFORECAST.WIZARD' })}
                width="90vw"
                height="92vh"
                minWidth={800}
                minHeight={600}
                // minWidth='1200px'
                // minHeight='1000px'
                // maxWidth="1200px"
                // maxHeight="1000px"
                maxWidth={1500}
                maxHeight={1000}
            >
                <TabPanel
                    width="100%"
                    deferRendering={false}
                    animationEnabled={true}
                    focusStateEnabled={true}
                    hoverStateEnabled={true}
                    swipeEnabled={false}
                    //selectedIndex={this.effectiveForecastBatchId ? 1 : 0}
                >
                    {
                        !this.effectiveForecastBatchId
                            ? <Item
                                height="100%"
                                render={this.tabFirstWizardPage}
                                />
                            : <Item
                                height="100%"
                                render={() => this.tabSecondWizardPage(this.effectiveForecastBatchId)}
                                />
                    }
                </TabPanel>
            </Popup>
        );
    }
}

export default injectIntl(ProjectOrderBatchModal);